export enum ConfigPanelMode {
  MODE_EXPANDED = 'expanded',
  MODE_COLLAPSED = 'collapsed',
  MODE_HIDDEN = 'hidden',
}

export enum ConfigRightSideScreen {
  SCREEN_ITEMS = 'items',
  SCREEN_RAWS = 'raws',
  SCREEN_MISSIONS = 'missions',
}
